import { createClient } from "@supabase/supabase-js";

export const supabaseClient = createClient(
  process.env.REACT_APP_SUPABASE_URL!,
  process.env.REACT_APP_SUPABASE_ANON_KEY!
);

export const get_my_claims = async () => {
  const { data, error } = await supabaseClient.rpc("get_my_claims", {});
  return { data, error };
};
